module.exports = __webpack_public_path__ + "static/media/bodiometer-desktop-bg.bd590368.mp4";